




import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "mrr-stat-base": () =>
      import("@/components/app/global/stats/mrrStatBase.vue")
  }
})
export default class MRRClientAverageStat extends Vue {
  @Prop({ required: true })
  public readonly dateFrom!: Date;

  // Getters
  public get valuePath() {
    return `result.${this.$moment(this.dateFrom).format("YYYY-MM-DD")}.${
      this.$attrs["currency-code"]
    }.mrr_client_avg_formatted`;
  }

  public get attrs() {
    return this.$_.merge(
      {
        label: this.$t("_.client_average"),
        valuePath: this.valuePath,
        dateFrom: this.dateFrom
      },
      this.$attrs
    );
  }
}
